import createStyles from "@mui/styles/createStyles";

export const useStyles = (theme) =>
  createStyles({
    buyflowContainer: {
      padding: theme.spacing(1, 2),
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(0),
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(0),
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(0, 20, 0, 20),
      },
    },
  });
